import React, { useEffect } from 'react';
import IApplicationReviewSummary from '../../../interfaces/IApplicationReviewSummary';
import { useQuery } from '@apollo/client';
import { GET_APPLICATION_REVIEWS } from '../../../graphql/member';

const useApplicationReviews = () => {
    const [applicationReviews, setApplicationReviews] =
        React.useState<IApplicationReviewSummary[]>();

    const { data, loading, error, refetch } = useQuery(GET_APPLICATION_REVIEWS);

    useEffect(() => {
        if (!loading && !error) {
            setApplicationReviews(data.accreditationApplicationReviewSummaries);
        }
    }, [data, loading, error]);

    return {
        models: {
            applicationReviews,
            loading,
        },
        operations: {
            refetch,
        },
    };
};

export default useApplicationReviews;
